import React from 'react'

import { cn } from '@/utilities/ui'

/** Icon + label grid tuned for the ~30rem room-detail sidebar (never 3 columns). */
export const roomDetailIconGridClassName =
  'grid grid-cols-1 gap-x-6 gap-y-3 min-[480px]:grid-cols-2'

export const roomDetailIconLabelClassName =
  'font-outfit text-base leading-5 text-balance text-dark-800/75'

type RoomDetailIconListProps = {
  'aria-label': string
  children: React.ReactNode
  className?: string
}

export function RoomDetailIconList({
  'aria-label': ariaLabel,
  children,
  className,
}: RoomDetailIconListProps) {
  return (
    <ul aria-label={ariaLabel} className={cn(roomDetailIconGridClassName, className)}>
      {children}
    </ul>
  )
}

type RoomDetailIconListItemProps = {
  children: React.ReactNode
  icon: React.ReactNode
}

export function RoomDetailIconListItem({ children, icon }: RoomDetailIconListItemProps) {
  return (
    <li className="flex min-w-0 items-start gap-2">
      <span className="mt-0.5 shrink-0">{icon}</span>
      <span className={roomDetailIconLabelClassName}>{children}</span>
    </li>
  )
}
